import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalstorageService {

    setItem(key: string, data: string) {
        localStorage.setItem(key, data);
    }

    getItem(key: string): string {
        return localStorage.getItem(key) || '';
    }

    removeItem(key: string) {
        localStorage.removeItem(key);
    }

    getParsedItem<T>(key: string): T | null {
        const raw = this.getItem(key);

        if (!raw || raw.trim() === '' || raw === '{}') return null;

        return JSON.parse(raw) as T;
    }
}
